export const routeRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const routeRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const routeModeList = {
  VIEW_ROUTE_DETAIL: "VIEW_ROUTE_DETAIL",
  EDIT_ROUTE_DETAIL: "EDIT_ROUTE_DETAIL",
};

export const getInitRouteParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    columnFilterKeep: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "hub,maker,checker",
  };
};
